"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-ui-sdk/CanSpamSettings/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/DoiPages/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/DoiSettings/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-ui-sdk/LandingPages/reducer"));

var _reducer5 = _interopRequireDefault(require("settings-ui-sdk/SmtpTokens/reducer"));

var _reducer6 = _interopRequireDefault(require("settings-ui-sdk/SubscriptionDefinitions/reducer"));

var _reducer7 = _interopRequireDefault(require("settings-ui-sdk/SubscriptionEmails/reducer"));

var _portalDragAndDropAvailable = _interopRequireDefault(require("EmailData/reducers/portalDragAndDropAvailable"));

var _default = (0, _redux.combineReducers)({
  canSpamSettings: _reducer.default,
  doiPages: _reducer2.default,
  doiSettings: _reducer3.default,
  landingPages: _reducer4.default,
  smtpTokens: _reducer5.default,
  subscriptionDefinitions: _reducer6.default,
  subscriptionEmails: _reducer7.default,
  portalDragAndDropAvailable: _portalDragAndDropAvailable.default
});

exports.default = _default;
module.exports = exports.default;